import React from "react";

const UserAvatarIcon = ({ invert }) => {
    return invert ? (
        <svg
            width="28"
            height="28"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.2368 20C15.7516 20 20.2368 15.5147 20.2368 10C20.2368 4.48525 15.7516 0 10.2368 0C4.72207 0 0.236816 4.48525 0.236816 10C0.236816 15.5147 4.72207 20 10.2368 20ZM10.2368 0.75C15.3363 0.75 19.4868 4.9005 19.4868 10C19.4868 15.0995 15.3363 19.25 10.2368 19.25C5.13732 19.25 0.986816 15.0995 0.986816 10C0.986816 4.9005 5.13732 0.75 10.2368 0.75Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.63184 7.12688C6.63184 5.0665 8.30234 3.396 10.3627 3.396C12.4231 3.396 14.0936 5.0665 14.0936 7.12688C14.0936 8.30211 13.5498 9.35141 12.7001 10.0352C12.0174 9.60986 11.2227 9.36548 10.3627 9.36548C9.50274 9.36548 8.70807 9.60984 8.02531 10.0352C7.1756 9.35148 6.63184 8.30218 6.63184 7.12688Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3628 9.61377C7.68303 9.61377 5.63672 11.9959 5.63672 14.7689V15.3099C5.63672 15.8108 5.95477 16.3257 6.51441 16.4656L7.58332 16.7332C9.41332 17.1903 11.3123 17.1903 13.1423 16.7332L14.2112 16.4656C14.7708 16.3256 15.0889 15.8108 15.0889 15.3099V14.7689C15.0889 11.996 13.0425 9.61377 10.3628 9.61377Z"
                fill="white"
            />
        </svg>
    ) : (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.75669 23.0878C9.77622 23.1243 9.79705 23.1608 9.827 23.1946C9.83352 23.2011 9.84003 23.2076 9.84654 23.2141C9.85956 23.2272 9.87258 23.2441 9.8869 23.2545C11.6004 24.6608 13.7736 25.4342 15.9962 25.4342C18.2202 25.4342 20.3932 24.6608 22.1056 23.2545L22.1459 23.2141C22.1524 23.2076 22.1629 23.2011 22.1694 23.1907C22.1993 23.1569 22.2228 23.1204 22.2397 23.0839C22.2397 23.0839 22.2397 23.08 22.2436 23.0774C22.5939 22.3235 22.7735 21.5071 22.7735 20.6477C22.7735 18.5748 21.6642 16.6517 19.8373 15.4851C20.5834 14.6049 21.0379 13.472 21.0379 12.2312C21.0379 9.45512 18.7775 7.19482 16.0015 7.19482C13.2256 7.19482 10.9652 9.45522 10.9652 12.2312C10.9652 13.4708 11.4183 14.6049 12.1618 15.4851C10.335 16.6517 9.22559 18.5749 9.22559 20.6477C9.22559 21.4941 9.40267 22.3105 9.75162 23.0748C9.75162 23.0748 9.75553 23.0813 9.75813 23.0813L9.75669 23.0878ZM11.9637 12.2375C11.9637 10.0109 13.7736 8.20117 16.0001 8.20117C18.2265 8.20117 20.0364 10.0111 20.0364 12.2375C20.0364 14.4641 18.2265 16.2738 16.0001 16.2738C13.7736 16.2738 11.9637 14.4639 11.9637 12.2375ZM12.9064 16.2035C13.7593 16.8702 14.8335 17.2738 16.0002 17.2738C17.1668 17.2738 18.2371 16.8702 19.0939 16.2035C20.7567 17.1696 21.7775 18.8467 21.7775 20.6542C21.7775 21.3273 21.6408 21.968 21.3843 22.5578C19.8608 23.7713 17.9573 24.4406 16.0016 24.4406C14.0446 24.4406 12.1423 23.77 10.6189 22.5578C10.3585 21.9575 10.2257 21.3182 10.2257 20.6542C10.2257 18.8469 11.2452 17.1712 12.9093 16.2035H12.9064Z"
                fill="white"
            />
            <path
                d="M15.9998 29.3334C23.3528 29.3334 29.3332 23.3531 29.3332 16.0001C29.3332 8.64708 23.3528 2.66675 15.9998 2.66675C8.64684 2.66675 2.6665 8.64708 2.6665 16.0001C2.6665 23.3531 8.64684 29.3334 15.9998 29.3334ZM15.9998 3.66675C22.7992 3.66675 28.3332 9.20075 28.3332 16.0001C28.3332 22.7994 22.7992 28.3334 15.9998 28.3334C9.2005 28.3334 3.6665 22.7994 3.6665 16.0001C3.6665 9.20075 9.2005 3.66675 15.9998 3.66675Z"
                fill="white"
            />
        </svg>
    );
};

export default UserAvatarIcon;
